module.exports = __webpack_public_path__ + "static/media/Pic-0199.c010f65a.jpg";